import { Category } from './types';

export const PRODUCT_GROUPS_LEADERBOARD_FEATURE_FLAG = 'pg-leaderboard';

export const BETA_FLAG_STORAGE_KEY = 'gfknewron_feature_flag';
export const BETA_FLAG = 'beta';

const leaderboardCategories = [
  Category.brands,
  Category.regions,
  Category.features,
  Category.countries,
  Category.productGroups,
];

export const isLeaderboardCategory = (category: Category, categories = leaderboardCategories): boolean => {
  return categories.includes(category);
};

/* to check beta feature flag */
export const hasBetaFeatureFlag = () => {
  const featureFlagString = localStorage.getItem(BETA_FLAG_STORAGE_KEY);
  return featureFlagString ? featureFlagString.includes(BETA_FLAG) : false;
};
